// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  baseUrl: 'https://api-dev.financelogix.com/',
  wsUrl: 'ws://api-dev.financelogix.com/ws',
  

  pageHeaders: {
    dashboard: {
      title: 'Welcome',
      description: 'Ready to start your day with a financial overview?'
    },
    transactions: {
      title: 'Transactions',
      description: 'Track Every Move and Understand Your Spending Smarter'
    },
    creditScore: {
      title: 'Credit Score',
      description: 'Monitor your credit health and make informed decisions'
    },
    offers: {
      title: 'Offers',
      description: 'Discover Personalized Offers That Match Your Financial Goals.'
    },
    settings: {
      title: 'Settings',
      description: 'Control Your Preferences. Maintain Your Experience.'
    },
    notifications: {
      title: 'Notifications',
      description: 'Stay Informed. Stay Connected Always.'
    },

  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
